<script setup lang="ts">
import type { ColorMarkedSegment } from "~/utils/colorMarkedText";

const props = defineProps<{
  text: string;
}>();

const segments = computed(() => parseColorMarkedText(props.text));

function segmentStyle(segment: ColorMarkedSegment) {
  return {
    ...(segment.color ? { color: segment.color } : {}),
    ...(segment.bold ? { fontWeight: "bold" } : {}),
  };
}
</script>

<template>
  <template v-for="(segment, index) in segments" :key="index">
    <span
      v-if="segment.color || segment.bold"
      :style="segmentStyle(segment)"
      >{{ segment.text }}</span
    >
    <template v-else>{{ segment.text }}</template>
  </template>
</template>
